import { useTranslation } from "react-i18next";
import {
  FOOTER_ADDRESS_KEY,
  FOOTER_COPYRIGHT_KEY,
} from "@/components/Layout/footer/footerData";
import "./FooterLegal.css";

export function FooterLegal() {
  const { t } = useTranslation();

  return (
    <div className="site-footer__legal">
      <p>{t(FOOTER_COPYRIGHT_KEY)}</p>
      <p className="site-footer__address">{t(FOOTER_ADDRESS_KEY)}</p>
    </div>
  );
}
